import { useState, useEffect } from 'react';

export const useOnboarding = (storageKey = 'onboardingCompleted') => {
  const [shouldShowOnboarding, setShouldShowOnboarding] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkOnboardingStatus = () => {
      try {
        const completed = localStorage.getItem(`${storageKey}`);
        const skipped = localStorage.getItem(`${storageKey.replace('Completed', 'Skipped')}`);
        const date = localStorage.getItem(`${storageKey.replace('Completed', 'Date')}`);
        
        // Se nunca foi mostrado e não foi pulado, mostrar
        const shouldShow = !completed && !skipped;
        
        console.log('🎯 Verificando status do onboarding:', {
          storageKey,
          completed: !!completed,
          skipped: !!skipped,
          date,
          shouldShow
        });
        
        setShouldShowOnboarding(shouldShow);
      } catch (error) {
        console.error('Erro ao verificar status do onboarding:', error);
        setShouldShowOnboarding(false);
      } finally {
        setIsLoading(false);
      }
    };

    // Dar um pequeno delay para não mostrar imediatamente
    const timer = setTimeout(checkOnboardingStatus, 1000);
    
    return () => clearTimeout(timer);
  }, [storageKey]);

  const markAsCompleted = () => {
    localStorage.setItem(storageKey, 'true');
    localStorage.setItem(storageKey.replace('Completed', 'Date'), new Date().toISOString());
    setShouldShowOnboarding(false);
  };

  const markAsSkipped = () => {
    localStorage.setItem(storageKey.replace('Completed', 'Skipped'), 'true');
    localStorage.setItem(storageKey.replace('Completed', 'Date'), new Date().toISOString());
    setShouldShowOnboarding(false);
  };

  const resetOnboarding = () => {
    localStorage.removeItem(storageKey);
    localStorage.removeItem(storageKey.replace('Completed', 'Skipped'));
    localStorage.removeItem(storageKey.replace('Completed', 'Date'));
    setShouldShowOnboarding(true);
  };

  const hideOnboarding = () => {
    setShouldShowOnboarding(false);
  };

  return {
    shouldShowOnboarding,
    isLoading,
    markAsCompleted,
    markAsSkipped,
    resetOnboarding,
    hideOnboarding
  };
};

export default useOnboarding;
